import React from 'react';
import { Icon, P } from '@fashionnovateam/nova-ui-toolkit';

type FileItemProps = {
  fileName: string;
  onDownload?: () => void;
  downloadDisabled?: boolean;
  onRemove?: () => void;
  'data-testid'?: string;
};

export function FileItem({
  fileName,
  onDownload,
  downloadDisabled,
  onRemove,
  'data-testid': dataTestId,
}: FileItemProps): React.JSX.Element {
  return (
    <div
      role={downloadDisabled ? undefined : 'button'}
      tabIndex={downloadDisabled ? undefined : 0}
      data-testid={dataTestId}
      className={`flex items-center gap-2.5 px-2.5 py-2 bg-white border border-gray-200 rounded-lg shadow-sm ${
        downloadDisabled ? 'cursor-default' : 'cursor-pointer hover:shadow-md'
      } transition-shadow`}
      onClick={downloadDisabled ? undefined : onDownload}
      onKeyDown={
        downloadDisabled
          ? undefined
          : (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onDownload?.();
              }
            }
      }
    >
      <Icon
        name="file-02/file-02-text"
        color="gray"
        className="flex-shrink-0"
      />
      <div className="flex flex-col min-w-0 flex-1">
        <P size="xsm" className="truncate">
          {fileName}
        </P>
        <P size="2xs" weight="medium" color="disabled">
          PDF
        </P>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="flex-shrink-0 p-1.5 rounded hover:bg-red-50 text-gray-400 hover:text-red-500 transition-colors"
          aria-label="Remove file"
        >
          <Icon name="delete/delete-dustbin-01" />
        </button>
      )}
    </div>
  );
}
